// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7dd4af75","453":"9d87fd52","455":"fe4dfe5f","977":"363a0adb"}[chunkId] + ".chunk.js";
};